import { useMutation, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../../config/constants";
import { toast } from "../../components/ui/Toast/useToast";
import { size } from "lodash";
import { 
  getDeliveryGetStatusFn,
  getDeliveryInitializeFieldsFn, 
  getVehicleDeliveryCurrentStepFn, 
  getVehicleDeliveryShowSummaryFn, 
  vehicleDeliveryAdditionalCommentsFn, 
  vehicleDeliveryAddressFn, 
  vehicleDeliveryBookingFn, 
  vehicleDeliveryEntryBookingStepFn, 
  vehicleDeliveryOptionSelectionFn 
} from "../../transactions/deliveryBooking/deliveryBooking";
import { useDeliveryFlowStore } from "../../store/newVehicleDeliveryStore";

const { VEHICLE_DELIVERY_CREATE_INPUTS, VEHICLE_DELIVERY_FLOW_ID, VEHICLE_DELIVERY_INFO} = QUERY_KEYS;

const genericError = ({message}) => {
  toast({
    variant: "destructive",
    description: message || "Παρουσιάστηκε κάποιο πρόβλημα",
  });
};

// Fetching



// export const useGetDeliveryStatus = ({plateno: plateNumber, enabled:enable}) => {
//    const setDeliveryStatus = useDeliveryFlowStore((s) => s.setDeliveryStatus);

//   return useQuery({
//       queryKey: [VEHICLE_DELIVERY_INFO, plateNumber],
//       queryFn: () => getDeliveryGetStatusFn({plateno: plateNumber}),
//       staleTime: Infinity,
//       enabled: enable,
//       onSuccess: (data) => {
//         if (!plateNumber) return;
//         setDeliveryStatus(plateNumber, data?.data);
//       },
//     });
// };


export const useGetDeliveryStatus = ({ plateno: plateNumber, enabled }) => {
  const setDeliveryStatus = useDeliveryFlowStore((s) => s.setDeliveryStatus);

  return useQuery({
    queryKey: [VEHICLE_DELIVERY_INFO, plateNumber],
    enabled: enabled && !!plateNumber,
    staleTime: Infinity,
    cacheTime: Infinity,
    queryFn: async () => {
      return getDeliveryGetStatusFn({ plateno: plateNumber });

      // const real = await getDeliveryGetStatusFn({ plateno: plateNumber });

      // // ✅ MOCK HERE
      // return {
      //   ...real?.data,
      //   data: {
      //     ...real.data,
      //     deliveryLocation: {
      //       ...real.data?.deliveryLocation,
      //       // garageName: "RAC",
      //       garageName: "AUTHORIZED",
      //     },
      //   },
      // };
    },

    onSuccess: (data) => {
      if (!plateNumber) return;
      setDeliveryStatus(plateNumber, data?.data);
    },
  });
};


export const useGetInitiateService = (plateNumber) => {
  return useQuery({
    queryKey: [VEHICLE_DELIVERY_CREATE_INPUTS, plateNumber],
    queryFn: () => getDeliveryInitializeFieldsFn(),
    refetchOnWindowFocus: false
  });
};

export const useGetShowSummary = ({ vehicleFlowId, enabled }) => {
  return useQuery({
    queryKey: ['SERVICE_FLOW_SUMMARY', vehicleFlowId],
    queryFn: () => getVehicleDeliveryShowSummaryFn(vehicleFlowId),
    enabled: !!vehicleFlowId && enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useGetCurrentStep = (vehicleFlowId) => {
  return useQuery({
    queryKey: [VEHICLE_DELIVERY_FLOW_ID, vehicleFlowId],
    queryFn: () => getVehicleDeliveryCurrentStepFn(vehicleFlowId),
    staleTime: 5 * 60 * 1000,
    cacheTime: Infinity,
    refetchOnWindowFocus: false
  });
};

// Mutating

// ToDo:
// IF there are no different onSuccess handlers
// by the end of the project => Reduce boilerplate

export const useEntryBooking = () => {
  return useMutation({
    mutationFn: ({ payload }) =>
      vehicleDeliveryEntryBookingStepFn({
        payload: payload,
      }),
    onError: genericError,
  });
};

export const useOptionSelection = () => {
  return useMutation({
    mutationFn: ({ vehicleFlowId, payload }) =>
      vehicleDeliveryOptionSelectionFn({
        vehicleFlowId: vehicleFlowId,
        payload: payload,
      }),
    onError: genericError,
  });
};

export const useDeliveryAddress = () => {
  return useMutation({
    mutationFn: ({ vehicleFlowId, payload }) =>
      vehicleDeliveryAddressFn({
        vehicleFlowId: vehicleFlowId,
        payload: payload,
      }),
    onError: genericError,
  });
};


export const useBooking = () => {
  return useMutation({
    mutationFn: ({ vehicleFlowId, payload }) =>
      vehicleDeliveryBookingFn({
        vehicleFlowId: vehicleFlowId,
        payload: payload,
      }),
    onError: genericError,
  });
};

export const useAdditionalComments = () => {
  return useMutation({
    mutationFn: ({ vehicleFlowId, payload }) =>
      vehicleDeliveryAdditionalCommentsFn({
        vehicleFlowId: vehicleFlowId,
        payload: payload,
      }),
    onError: genericError,
  });
};
